import { Component, Input } from '@angular/core';
import { Contact } from '../models/Contact';

@Component({
  selector: 'email-recipients-readonly-input',
  templateUrl: './email-recipients-readonly-input.component.html',
})
export class EmailRecipientsReadonlyInputComponent {
  readonly ValueNotProvided = 'Not provided';

  @Input() emailRecipient: Contact;
  @Input() label: string;
  @Input() helpText: string;

  getContactValue(): string {
    return this.emailRecipient?.value ?? this.ValueNotProvided;
  }
}
